import { CMS_API_URL } from 'constants/apiConf';

export const getCMSDocumentSrc = (document) => {
  return `${CMS_API_URL}${CMS_API_URL.endsWith('/') ? '' : '/'}cms/documents/public/${document.hash}`;
};
